module.exports = __webpack_public_path__ + "videos/3d-model_cn-hevc.5f6f751.mp4";